module.exports = __webpack_public_path__ + "static/media/Roadside-Billboard_840x400@2x.d6b23436.png";